import { apiEndPoints } from './api-end-points';
import { routePaths } from './route-paths';

const currentYear = new Date().getFullYear();
export const common = {
  blank: '',
  parseIntRadix: 10,
  businessNewAdress: 'new',
  businessSameAddress: 'same',
  cookiesExpriesTime: 86400000,
  defaultPageLimit: 1000,
  imageUploadSize: 5242880,
  rowsPerPage: 10,
  startCalenderDate: { year: 1910, month: 1, day: 1 },
  tax_year: currentYear - 1,
  error_code: 400,
  cra_login: 'CRA LOGIN',
  cra_error: 'Error, Please try again',
  cra_url: `https://www.canada.ca/en/revenue-agency/services/e-services/cra-login-services/cra-user-password-help-faqs/registration-process-access-cra-login-services.html`,
  problumWithSigh: `https://www.canada.ca/en/revenue-agency/services/e-services/cra-login-services/cra-user-password-help-faqs/problems-entering-your-personal-authentication-information-account-individuals-business-account.html`,
};

export const apiMethods = {
  post: 'post',
  put: 'put',
  delete: 'delete',
  get: 'get',
  patch: 'patch',
  request: 'request',
};

export const httpStatusCode = {
  notFound: 404,
  ok: 200,
  created: 201,
  unAuthorize: 401,
  unAuthenticate: 403,
};

export const maritalStatus = {
  single: 'single',
  divorced: 'divorced',
  widowed: 'widowed',
  separated: 'separated',
  married: 'married',
  living: 'living',
};
export const defaultValues = {
  ownership: 'self',
  businessAddress: 'same',
  businessFirstLast: 'neither',
};
export const genderDefault = [
  { id: 1, name: 'male' },
  { id: 2, name: 'female' },
  { id: 3, name: 'others' },
];
export const languageDefault = [
  { id: 1, name: 'english' },
  { id: 2, name: 'french' },
];

export const insuranceProgramme = [
  { id: 1, name: 'Government', value: true },
  { id: 2, name: 'Private', value: false },
];
export const baseYear = 1970;
export const ageAtEighteen = 18;
export const dependantsElementsId = {
  id: 'id',
  sin: 'sin',
  isValidAge: 'isValidAge',
};
export const dependantsElementsNotRequired = [
  'id',
  'netIncome',
  'totalSplitIncome',
  'deductionNetIncome',
  'fedralNonRefundCredit',
  'provincialsNonRefundCredit',
];
export const passwordTypes = {
  password: 'password',
  text: 'text',
};
export const asciiCodes = {
  space: 32,
  zero: 48,
  nine: 57,
  enter: 13,
};

export const otpTypes = {
  onSignup: '1',
  onResetPassword: '2',
};
export const ToastrClasses = {
  error: 'toast-error',
  info: 'toast-info',
  success: 'toast-success',
  warning: 'toast-warning',
};

export const IncomeSlipsFormsId = {
  t2202Tuition: 1,
  t3TrustIncomeTax: 2,
  t4RifTax: 3,
  t4APension: 4,
  t4RspIncome: 5,
  t4PsIncome: 6,
  t4Enumeration: 7,
  t5Investment: 8,
  t5008Securities: 9,
  rrspRetirement: 10,
  donationSlip: 11,
  medicalSlip: 12,
  t101Slip: 13,
  t5013Slip: 14,
  t4aOasSecurity: 15,
  t4ApCppQpp: 16,
  t4eBenefits: 17,
  rc210Cwb: 18,
  t5007Benefits: 19,
  rc62UCCB: 20,
  t4arcaArrangement: 21,
  T5006RegisteredLabour: 22,
  foreignIncome: 23,
  t10PensionAdjustment: 24,
  selfEmploymentIncome: 25,
  t1139Form: 26,
  selfBusinessIncome: 27,
  businessIncome: 28,
  businessVehicleExpenses: 29,
  personalVehicleExpenses: 30,
  advertising: 31,
  entertainment: 32,
  wages: 33,
  businessRelated: 34,
  doubtfulAccount: 35,
  otherEmploymentIncome: 36,
  clergyResidenceDeduction2: 37,
  employementExpenses: 38,
  gstRebate: 39,
  additionalCppQpp: 40,
  repayments: 41,
  longHaul: 42,
  shortHaul: 43,
  wageLossReplacement: 44,
  transportEmployee: 45,
  licensesTaxes: 46,
  commercialInsurance: 47,
  clergyResidenceDeduction: 48,
  deferredStock: 49,
  employeeProfitSharing: 50,
  employmentStatusProfile: 51,
  businessCategory: 52,
  workBusiness: 53,
  aboutPartnership: 54,
  partnershipDetails: 55,
  expensesPartnership: 56,
  equityPartnership: 57,
  earnedIncomeWebsite: 58,
  interestMaintenance: 59,
  officeSupplies: 60,
  bankingFeesAdvice: 61,
  taxesRent: 62,
  utilitiesBusiness: 63,
  otherExpenses: 64,
  uccBalances: 65,
  additionDisposition: 66,
  homeForWork: 67,
  homeUseForWork: 68,
  homeYouUseForWork: 69,
  homeExpenses: 70,
  selfEmploymentRevenue: 71,
  reservesDeducted: 72,
  sellProductBought: 73,
  fishingIncome: 74,
  fishingIntro: 75,
  otherFishingIncome: 76,
  fishingExpenses: 77,
  otherFishingExpenses: 78,
  otherDeductions: 79,
  fishingReconciliationForm: 80,
  fishingHomeForWork: 81,
  farmingIncome: 82,
  otherFarmingIncome: 83,
  farmingLiveStockSold: 84,
  farmingProgramPayment: 85,
  farmingIntro: 86,
  farmingExpenses: 87,
  farmingProgramOverpayment: 88,
  farmingExpensesLiveStock: 89,
  otherFarmingExpenses: 90,
  farmingNonArmLength: 91,
  otherFarmingDeduction: 92,
  quotaAdditionDisposition: 93,
  inventoryAdjustment: 94,
  farmingReconciliationForm: 95,
  investmentExpenseData: 96,
  investmentExpensesIntro: 97,
  interestExpenses: 98,
  carryingCharges: 99,
  taxOnSplitIncomeIntro: 100,
  agriStabilityInvestIncome: 101,
  agriStabilityInvestExpenses: 102,
  agriStabilityOtherDeductions: 103,
  taxOnSplitIncome: 104,
  taxAdjustedIncome: 105,
  rentalPropertyIntro: 106,
  rentalIncome: 107,
  rentalPartnerDetailsStatement: 108,
  rentalExpenses: 109,
  employementExpensesIntro: 110,
  employmentExpensesProfile: 111,
  t2200sEmploymentExpense: 112,
  gstHstRebate: 113,
  rrspProfile: 114,
  rrspDeductionLimit: 115,
  rrspContribution: 116,
  foreignRetirementPlanProfile: 117,
  contributionTemporaryAssignment: 118,
  contributionComputerCanada: 119,
  contributionForeignEmployer: 120,
  unusedRrspDeductionLimit: 121,
  saskatchewanPensionPlan: 122,
  pooledRegisteredPensionPlan: 123,
  homeBuyerPlanProfile: 124,
  homeBuyerPlan: 125,
  additionalHomeBuyerPlan: 126,
  lifelongLearningPlan: 127,
  lifelongLearningProfile: 128,
  additionalLlpWithdrawal: 129,
  transferRrspPrpp: 130,
  refundUnusedRrspPrpp: 131,
  rrspCalculator: 132,
  paymentProfile: 133,
  amateurAthleteTrust: 134,
  registeredPensionPlan: 135,
  donationProfile: 136,
  rrspPrppCarryForward: 137,
  charitableDonationCarriedForward: 138,
  charitableDonation: 139,
  usDonationReceipt: 140,
  unitedState: 141,
  sharesDonation: 142,
  capitalDonation: 143,
  culturalEcologicalGift: 144,
  otherDonation: 145,
  maxiMizingCharitableDonation: 146,
  donationClaimedCarriedForward: 147,
  firstTimeHomeBuyer: 148,
  repaymentFederalCovid: 149,
  unionProfessionalMember: 150,
  digitalNewsSubscription: 151,
  politicalContribution: 152,
  paidTaxInstalment: 153,
  foreignTaxCredits: 154,
  homeAccessibilityExpense: 155,
  disabilitySupportPayment: 156,
  disabilityAmount: 157,
  agriStabilityInvestIntro: 158,
  medicalProfile: 159,
  medicalExpense: 160,
  medicalExpenseReceipt: 161,
  privateMedicalPlan: 162,
  medicalExpenseClaim: 163,
  movingProfile: 164,
  movingProfileCarriedForward: 165,
  howFarDidYouMoved: 166,
  reasonOfMoving: 167,
  saleYourOldHouse: 168,
  detailsOfTheMove: 169,
  allowableMovingExpense: 170,
  newHomeExpense: 171,
  eligibleIncomeAtNewLocation: 172,
  studentProfile: 173,
  taxBreakGoingSchool: 174,
  unusedTuitionEducation: 175,
  studentLoanInterestProfile: 176,
  studentLoanInterest: 177,
  researchGrantExpense: 178,
  eligibleReceiveCanadaTraining: 179,
  totalCreditReceiving: 180,
  employmentRelatedDriving: 181,
  otherEmploymentExpenses: 182,
  workSpaceHomeExpense: 183,
  eligibleEducatorTaxCredit: 184,
  northernResidentDeduction: 185,
  northernResidentDeductionTrips: 186,
  additionalResidencyAmount: 187,
  volunteerFireFighterRescue: 188,
  otherDeduct: 189,
  additionalDeduction: 190,
  additionalTaxAccumulatedResp: 191,
  ontarioProvinceProfile: 192,
  homeownerPropertyTaxGrant: 193,
  homeSafetyTaxCredit: 194,
  addressOfProperty: 195,
  ontarioTrilliumBenefit: 196,
  applyForOntarioTrilliumBenefit: 197,
  ontarioSelfEmploymentTaxCredit: 198,
  cooperativeEducationTaxCredit: 199,
  ontarioOpportunitiesFund: 200,
  climateActionIncentive: 201,
  lossesProfile: 202,
  allowableBusinessInvestmentLoss: 203,
  nonCapitalLossesCarryForward: 204,
  nonCapitalLossesBeingClaimed: 205,
  paymentRelatedPrincipal: 206,
  restrictedFarmingLossCarry: 207,
  restrictedFarmingLossClaimed: 208,
  farmingFishingLossCarryForward: 209,
  farmingFishingLossCarryClaimed: 210,
  personalPropertyLossCarryForward: 211,
  listedPersonalPropertyLoss: 212,
  limitedPartnershipLoss: 213,
  netCapitalLossCarryForward: 214,
  netCapitalLossClaimedForward: 215,
  nonCapitalLossCarrybacks: 216,
  farmingFishingLossCarrybacks: 217,
  netCapitalLossCarrybacks: 218,
  lppLossCarrybacks: 219,
  restrictedFarmLossCarrybacks: 220,
  lossesProfileSummary: 221,
  albertaTaxCreditProfile: 222,
  stockSavingsPlanTaxCredit: 223,
  investorTaxCredit: 224,
  britishColumbiaTaxCredit: 225,
  bcSalesTaxCredit: 226,
  homeRenovationTaxCredit: 227,
  trainingTaxCreditIndividual: 228,
  trainingTaxCreditEmployer: 229,
  trainingTaxCreditShipbuilding: 230,
  miningExplorationTaxCredit: 231,
  miningFlowThroughShareTaxCredit: 232,
  miningFlowThroughShareTaxCreditCarryback: 233,
  ventureCapital: 234,
  carryForwardCapitalGain: 235
};
export const MovingFormTypes = {
  159: `/${routePaths.itrSlips}/${routePaths.movingExpenseCarriedForward}`,
  160: `/${routePaths.itrSlips}/${routePaths.movingExpenseProfileForward}`,
  161: `/${routePaths.itrSlips}/${routePaths.movingProfileFarDidYouMoved}`,
  162: `/${routePaths.itrSlips}/${routePaths.reasonOfMoving}`,
  163: `/${routePaths.itrSlips}/${routePaths.saleOfYourOldHouse}`,
  164: `/${routePaths.itrSlips}/${routePaths.detailToMoveComponent}`,
  165: `/${routePaths.itrSlips}/${routePaths.allowableMovingExpense}`,
  166: `/${routePaths.itrSlips}/${routePaths.newMovingExpenses}`,
  167: `/${routePaths.itrSlips}/${routePaths.eligibleIncomeAtNewLocation}`,
};

export const ApiFormTypes = {
  159: `${apiEndPoints.deduction}${apiEndPoints.movingProfile}`,
  160: `${apiEndPoints.deduction}${apiEndPoints.movingProfileCarriedForward}`,
  161: `${apiEndPoints.deduction}${apiEndPoints.farDidYouMove}`,
  162: `${apiEndPoints.deduction}${apiEndPoints.reasonForMoving}`,
  163: `${apiEndPoints.deduction}${apiEndPoints.saleOfYourOldHome}`,
  164: `${apiEndPoints.deduction}${apiEndPoints.detailOfTheMove}`,
  165: `${apiEndPoints.deduction}${apiEndPoints.allowableMovingExpense}`,
  166: `${apiEndPoints.deduction}${apiEndPoints.newHomeExpense}`,
  167: `${apiEndPoints.deduction}${apiEndPoints.eligibleIncomeAtNewLocation}`,
};

export const labelTitle = {
  continueWithoutIncome: 'Continue Without Income',
  continueWithoutRrsp: 'Continue Without RRSP',
  continueWithoutDeduction: 'Continue Without Deduction',
};

export const enum ProvincialProfileConstant {
  homeownersPropertyTax = 1,
  selfEmploymentTax = 2,
  cai = 3,
}

export const ProvincialScreens = {
  info: 'info',
  profile: 'profile',
  propertyTax: 'property-tax',
  trilliumBenefit: 'trillium-benefit',
  principalResidence: 'payment-info',
  trilliumBenefitApply: 'trillium-benefit-apply',
  employmentTax: 'employment-tax',
  educationTax: 'education-tax',
  trainingTax: 'training-tax',
  opportunitiesFund: 'opportunities-fund',
  climateActionIncentive: 'climate-action-incentive',
  craditsForCai: 'credits-for-cai',
  caiSummary: 'cai-summary',
};

export const DefaultRefundAmount = 224;
export const slipsReferralTypes = {
  review: '2',
  edit: '1',
};

export const enum TaxSummaryTypeEnum {
  income = 1,
  rrsp = 2,
  deduction = 3,
  provincial = 4,
}

export const TaxSummaryTypeMapping = {
  1: 'income',
  2: 'rrsp',
  3: 'deduction',
};

export const ThresholdScrollValue = 50;
export const userTypes = {
  admin: '1',
  user: '2',
};

export enum genderEnum {
  male = 1,
  female = 2,
  other = 3,
}

export enum DonationEnum {
  political = 1,
  community,
  none,
}

export const DonationDefault = [
  { id: 1, name: 'political' },
  { id: 2, name: 'community' },
  { id: 3, name: 'none' },
];

export enum isBusinessNameMandatory {
  accural = 8,
  cash = 11,
}

export const ChartFilterOptions = [
  {
    value: 'weekly',
    name: 'Last Week',
  },
  {
    value: 'monthly',
    name: 'Last Month',
  },
  {
    value: 'six_month',
    name: 'Last 6 Months',
  },
  {
    value: 'year',
    name: 'Last Year',
  },
];

export const UserChartDataOptions = {
  xAxis: {
    labelString: `YEAR (${currentYear - 1}-${currentYear})`,
  },
  yAxis: {
    labelString: 'NUMBER OF USERS',
  },
  lineColor: [
    {
      backgroundColor: 'rgba(206, 207, 234, 0.3)',
      borderColor: 'rgb(63, 65, 159)',
      pointBackgroundColor: 'rgb(63, 65, 159, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: 'rgb(63, 65, 159)',
      pointHoverBorderColor: 'rgba(77,83,96,1)',
    },
  ],
  analytics_type: 'user',
};
export const ItrChartDataOptions = {
  xAxis: {
    labelString: `YEAR (${currentYear - 1}-${currentYear})`,
  },
  yAxis: {
    labelString: 'NUMBER OF TAX FILING',
  },
  lineColor: [
    {
      backgroundColor: 'rgba(245, 240, 255, 0.3)',
      borderColor: 'rgb(161, 111, 240)',
      pointBackgroundColor: 'rgba(161, 111, 240, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: 'rgb(161, 111, 240)',
      pointHoverBorderColor: 'rgba(77,83,96,1)',
    },
    {
      backgroundColor: 'rgba(255, 249, 237, 0.3)',
      borderColor: 'rgb(250, 192, 73)',
      pointBackgroundColor: 'rgba(250, 192, 73, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: 'rgb(250, 192, 73)',
      pointHoverBorderColor: 'rgba(77,83,96,1)',
    },
  ],
  analytics_type: 'itr',
};
export const RevenueChartDataOptions = {
  xAxis: {
    labelString: `YEAR (${currentYear - 1}-${currentYear})`,
  },
  yAxis: {
    labelString: 'REVENUE',
  },
  lineColor: [
    {
      backgroundColor: 'rgba(241, 248, 248, 0.3)',
      borderColor: 'rgba(70, 166, 164, 1)',
      pointBackgroundColor: 'rgba(70, 166, 164, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: 'rgba(70, 166, 164, 1)',
      pointHoverBorderColor: 'rgba(77,83,96,1)',
    },
  ],
  analytics_type: 'revenue',
};
